(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["er-product"]) return;
  try {
    
  function initializeErProducts(root = document) {
    root.querySelectorAll('[data-er-product]').forEach((section) => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      section.addEventListener('change', (event) => {
        if (!event.target.matches('input[name="id"]')) return;
        section.querySelector('[data-er-price]').textContent = event.target.dataset.price;
        const button = section.querySelector('[data-er-add]');
        const available = event.target.dataset.available === 'true';
        button.disabled = !available;
        button.firstChild.textContent = (available ? button.dataset.availableLabel : button.dataset.unavailableLabel) + ' ';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', event.target.value);
        window.history.replaceState({}, '', url);
      });
    });
  }
  initializeErProducts();
  document.addEventListener('shopify:section:load', (event) => initializeErProducts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
